import _ from 'lodash';
import { FiArrowRightCircle } from 'react-icons/fi';
import { SHOW_COMMEMORATE } from 'src/constants';
import useResponsive from 'src/utils/devices';
import styled from 'styled-components';
import CardV from './components/card-v';
import Carousels from './components/carousels';
import useVideoIframe from './utils';

const SectionSchneider = ({ id, eventDataLayer, data }) => {
  const responsive = useResponsive();

  if (_.isEmpty(data?.block1?.data) && _.isEmpty(data?.video)) return null;
  const background = { ...data?.background };
  const header = { ...data?.header };
  const footer = { ...data?.footer };

  return (
    <>
      <SectionWrapper id={id} header={header} style={{ filter: SHOW_COMMEMORATE === 'true' ? 'grayscale(0.8)' : 'unset' }}>
        {background.mobile && background.desktop && (
          <>
            {responsive.isMobile ? (
              <img className='background-event' src={background.mobile} width='100%' height='100%' />
            ) : (
              <img className='background-event' src={background.desktop} width='100%' height='100%' />
            )}
            <div className='container'>
              <div className='header-wrapper'>
                {responsive.isMobile ? header.mobile && <img src={header.mobile} width='100%' height='100%' /> : header.desktop && <img src={header.desktop} width='100%' height='100%' />}
              </div>

              <div className='block-wrapper'>
                <div className='block-1'>
                  <Carousels mobileSlideShow={1} slideShow={1} autoplay={true} infinite={true}>
                    {_.map(data?.video.slice(0, 3), (el, i) => (
                      <div key={i} className={`item-video --${i + 1}`}>
                        {useVideoIframe(el)}
                      </div>
                    ))}
                  </Carousels>
                </div>
                <div className='block-2'>
                  {responsive.isDesktop ? (
                    <div className='schneider-link'>
                      <a href={data?.block1?.link} target='_self' rel='noopener noreferrer' title='ดูทั้งหมด'>
                        <p>ดูทั้งหมด</p> <FiArrowRightCircle />
                      </a>
                    </div>
                  ) : null}
                  <Carousels mobileSlideShow={2} slideShow={responsive.isDesktop ? 3 : 2} autoplay={true} infinite={true} slidesToScroll={2}>
                    {_.map(data?.block1?.data.slice(0, 4), (el, i) => (
                      <div key={i} className={`item-card --${i + 1}`}>
                        <CardV
                          data={el}
                          color='#34b14b'
                          //! DATALAYER
                          eventDataLayer={{
                            ...eventDataLayer,
                            data: {
                              title: el.title,
                              carousel: i + 1
                            }
                          }}
                        />
                      </div>
                    ))}
                  </Carousels>
                  {responsive.isMobile ? (
                    <div className='schneider-link'>
                      <a href={data?.block1?.link} target='_self' rel='noopener noreferrer' title='ดูทั้งหมด'>
                        <p>ดูทั้งหมด</p> <FiArrowRightCircle />
                      </a>
                    </div>
                  ) : null}
                </div>
              </div>
              <div className='footer-wrapper'>
                {responsive.isMobile ? footer.mobile && <img src={footer.mobile} width='100%' height='100%' /> : footer.desktop && <img src={footer.desktop} width='100%' height='100%' />}
              </div>
            </div>
          </>
        )}
      </SectionWrapper>
    </>
  );
};

export default SectionSchneider;

const SectionWrapper = styled.div`
  position: relative;
  display: block;
  width: 100%;
  height: 100%;
  max-width: 100%;
  min-height: 300px;
  background-color: #55bb5b;
  @media ( max-width: 992px) {
      min-height: calc(100vw * 0.5);
  }
  @media (max-width: 767px) {
    min-height: calc(100vw * 1.4);

  }
  .background-event {
    position: relative;
    top: 0;
    left: 0;

    display: block;
    width: 100%;
    height: auto;
    max-width: 100%;
    object-fit: cover;
    @media (min-width: 1440px) {
      max-height: 560px;
    }
  }
  .schneider-link {
    position: absolute;
    top: -20px;
    right: 0px;
    a,
    svg {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      color: #fff;
      margin: 0 5px;
      transition: all 0.3s ease-in-out;
    }
    svg {
      margin-bottom: -2px;
    }
    &:hover {
      a,
      svg {
        color: #15431d94;
      }
    }
    @media (max-width: 767px) {
      position: relative !important;
      bottom: 0px;
      top: unset;
    }
  }
  /* -------------------------------- Carousels ------------------------------- */
  .slick-dots li {
    button:before {
      height: 5px !important;
      border-radius: 20px !important;
      background-color: #fff;
    }
  }
  .carousel-wrapper {
    margin: 0;
  }
  .slick-initialized .slick-slide {
    @media (min-width: 767px and max-width: 769px) {
      text-align: center;
    }
  }
  .slick-slide img {
    border-radius: 10px 10px 0 0;
  }
  /* -------------------------------------------------------------------------- */
  .container {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 100%;
    height: auto;
    object-fit: cover;
    transform: translate(-50%, -50%);
    padding: 15px;
    @media (max-width: 767px) {
      background-color: #55bb5b;
    }
    .header-wrapper,
    .footer-wrapper {
      display: block;
      max-width: 100%;
      @media (max-width: 767px) {
        margin: 20px 0;
      }
      @media (max-width: 380px) {
        margin: 5px 0;
      }
    }
    .block-wrapper {
      position: relative;
      display: flex;
      width: 100%;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      min-height: 300px;

      .block-1 {
        position: relative;

        width: 100%;
        max-width: 40%;
      }
      .block-2 {
        position: relative;

        width: 100%;
        max-width: 60%;
        padding-top: 20px;
      }
      @media (max-width: 1024px) {
        min-height: 200px;
        max-width: 100%;
        margin: auto;
      }
      @media (min-width: 767px) and (max-width: 769px) {
        .block-1 {
          max-width: 50%;
        }
        .block-2 {
          max-width: 50%;
          padding-top: 0;
          margin-top: -10px;
        }
      }
      @media (max-width: 767px) {
        /* max-width: 100%; */
        flex-direction: column;
        .block-1,
        .block-2 {
          max-width: 100%;
          padding: 0px;
        }
      }
      /* @media (max-width: 380px) {
        .block-2 .carousel-wrapper {
          padding-bottom: 30px;
        }
      } */
      /* @media (max-width: 480px) {
        padding: 15px 0;
      }
      @media (max-width: 380px) {
        padding: 5px 0;
      } */

      /* .block-1,
      .block-2 {
        max-width: 100%;
        width: 50%;

        @media (max-width: 767px) {
          width: 100%;
        }
      } */

      .item-card {
        padding: 5px;
        margin: 5px auto;
        @media (max-width: 1024px) {
          .footer-right {
            display: none;
          }
          .title {
            /* font-size: 14px; */
            margin-bottom: 5px;
          }
          .badge {
            font-size: 12px;
          }
        }
        @media (max-width: 767px) {
          .badge {
            display: none;
          }
          /* padding: 0; */
        }
      }

      .item-video {
        width: 100%;
        max-width: 95%;
        margin: 15px auto;
        display: block;
        background: rgb(37 123 52 / 58%);
        border-radius: 10px;
        padding: 30px 0;

        iframe {
          border-radius: 0;
        }
        @media (max-width: 769px) {
          max-width: 78%;
          margin: auto;
          padding: 10px 0;
        }
        @media (max-width: 767px) {
          max-width: 100%;
          padding: 30px 0;
          margin: 10px auto;
        }
      }
    }
  }
`;
